import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { useRoute } from "eddev/routing"
import { Appear } from "@components/motion/Appear"
import { HubspotForm } from "@components/atoms/HubspotForm"

export const meta: BlockMeta = {
  title: "Contact Page Form",
  tags: ["#page"],
}

export default defineBlock("content/contact-form", (props) => {
  const route = useRoute()
  const isContact = route.pathname.includes("contact")

  return (
    <div className={cn("w-full my-blockSpace", isContact && "py-6 mt-0 -mb-blockSpace bg-slate200")}>
      <div className="w-full content-sized grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="w-full aspect-[352/336] md:aspect-[519/573] h-full grid grid-rows-2 gap-4">
          <Appear className="w-full h-full flex flex-col justify-between rounded-md bg-slate600 text-slate50 p-5">
            <Appear slide delay={50}>
              <EditableText
                store="title"
                as="p"
                placeholder="Title"
                className="type-sans-base-semibold md:type-sans-xl-semibold text-pretty"
              />
            </Appear>
            <Appear slide delay={150}>
              <EditableText
                store="description"
                className="type-serif-lg-regular md:type-serif-2-xl-regular text-pretty"
                defaultValue="Description text"
                placeholder="Description text"
              />
            </Appear>
          </Appear>
          {props.image?.mediaItemUrl && (
            <Appear delay={300} className="w-full h-full rounded-md overflow-hidden bg-slate600">
              <Appear zoom duration={1000} className="w-full h-full">
                <ResponsiveImage {...props.image} className="w-full h-full" objectFit="cover" />
              </Appear>
            </Appear>
          )}
        </div>
        <div className="w-full aspect-[519/573] rounded-md flex flex-col justify-between p-5 bg-slate50">
          {props.hubspotFormSelection ? (
            <HubspotForm key={props.hubspotFormSelection} formId={props.hubspotFormSelection} />
          ) : props.hubspotFormId ? (
            <HubspotForm key={props.hubspotFormId} formId={props.hubspotFormId} />
          ) : (
            env.admin && (
              <div className="w-full h-full flex items-center justify-center text-slate950 type-sans-base-regular">
                Hubspot Form not configured. Please set the Form ID to display the form.
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
})
